<template>
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 64 64"
    style="enable-background:new 0 0 64 64;"
    xml:space="preserve"
  >
    <polygon
      v-if="fillColor !== undefined"
      id="polygon"
      class="st0"
      points="32,7 7,26.1 16.6,57 47.4,57 57,26.1 "
      :fill="fillColor"
      :stroke="fillStroke"
    />
    <path
      class="st0"
      d="M44,0"
    />
    <path
      class="st0"
      d="M0,6.3"
    />
    <line
      v-if="lineColor !== undefined"
      id="line"
      class="st0"
      x1="4.5"
      y1="59.5"
      x2="59.5"
      y2="4.5"
      :stroke="lineColor"
    />
    <circle
      v-if="circleColor !== undefined"
      id="circle"
      class="st0"
      cx="32"
      cy="32"
      r="17"
      :fill="circleColor"
    />
    <text
      v-if="textColor !== undefined"
      id="text"
      transform="matrix(1.2351 0 0 1 25.0791 58.2754)"
      class="st2 st3"
      :fill="textColor"
    >
      A
    </text>
    <text
      v-if="isExtrusion"
      id="extrusion"
      transform="matrix(1.1104 0 0 1 1.6129 17.7178)"
      class="st2 st4"
    >
      3D
    </text>
  </svg>
</template>

<script>
export default {
  name: 'LegendIcon',
  props: {
    lStyle: {
      type: Object,
      required: true,
      default: null,
    },
  },
  data() {
    return {
      circleColor: undefined,
      circleStroke: undefined,
      lineColor: undefined,
      fillColor: undefined,
      fillStroke: undefined,
      textColor: undefined,
      isExtrusion: false,
    };
  },
  computed: {},
  created() {
    const circleStyle = this.lStyle.circle;
    const lineStyle = this.lStyle.line;
    const fillStyle = this.lStyle.fill;
    const symbolStyle = this.lStyle.symbol;
    if (circleStyle) {
      this.setValueIfNotUndefined('circleColor', circleStyle, 'circle-color');
      this.setValueIfNotUndefined('circleStroke', circleStyle, 'circle-stroke-color');
    }
    if (lineStyle) {
      if (fillStyle) {
        this.setValueIfNotUndefined('fillStroke', lineStyle, 'line-color');
      } else {
        this.setValueIfNotUndefined('lineColor', lineStyle, 'line-color');
      }
    }
    if (fillStyle) {
      this.setValueIfNotUndefined('fillColor', fillStyle, 'fill-color');
    }
    if (symbolStyle) {
      this.setValueIfNotUndefined('textColor', symbolStyle, 'text-color');
    }
    this.isExtrusion = (typeof this.lStyle['fill-extrusion'] !== 'undefined');
  },
  methods: {
    checkIfMapboxExpression(expr) {
      // mapbox expressions are filtered out of legend because they cant be displayed
      if (expr) {
        if (typeof expr === 'object') {
          if (expr.length >= 0) {
            return true;
          }
        }
      }
      return false;
    },
    setValueIfNotUndefined(prop, style, styleProp) {
      if (!this.checkIfMapboxExpression(style[styleProp])) {
        this[prop] = (typeof style[styleProp] === 'undefined') ? undefined : style[styleProp];
      }
    },
  },
};
</script>

<style scoped>
  .st0{
    stroke-miterlimit:10;
  }
  .st1{
    fill:none;
    stroke-miterlimit:10;
}
  .st2{
    font-family: sans-serif;
    }
  .st3{
    font-size:42.2704px;
  }
  .st4{
    font-size:21.1353px;
  }
</style>
